module.exports = __webpack_public_path__ + "img/Galactapedia_Anvil_Aerospace.dae35869.png";